<template>
  <div>
    <vonap-window
      width="1082px"
      height="632px"
      title="Email preview"
      modal
      @close="close"
      v-model="show"
    >
      <div style="margin-bottom: 20px;">
        <div>
          <b>Client: </b><span>{{ clientName }}</span>
        </div>
        <div>
          <b>From: </b><span>{{ fromEmail }}</span>
        </div>
        <div>
          <b>To: </b><span>{{ toEmail }}</span>
        </div>
        <div>
          <b>Subject: </b><span>{{ subject }}</span>
        </div>
      </div>
      <v-card>
        <v-container grid-list-xl style="background-color:#e3e3e3">
          <span v-html="message"></span>
        </v-container>
      </v-card>
    </vonap-window>
  </div>
</template>

<script>
import axios from 'axios'
import VonapWindow from '@/components/VonapWindow'
import notification from '@/helpers/notification'

export default {
  name: 'UndeliveredBalancePreview',
  components: {
    VonapWindow,
  },
  props: {
    value: {type: Boolean},
    formParams: {type: Object},
  },
  data() {
    return {
      clientName: '',
      subject: '',
      fromEmail: '',
      toEmail: '',
      message: '',
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set() {},
    },
  },
  methods: {
    async getData() {
      const formData = this.formParams
      const response = await axios
        .post('/api/report/DrawDown/GetEmailPreview', formData)
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })

      this.clientName = response.data.clientName
      this.subject = response.data.subject
      this.fromEmail = response.data.fromEmail
      this.toEmail = response.data.toEmail
      this.message = response.data.message
    },
    close() {
      this.$emit('input', false)
    },
  },
  watch: {
    formParams(newVal) {
      if (newVal) {
        this.getData()
      }
    },
  },
}
</script>
